export default "__VITE_ASSET__Bu1fLmc5__"